import { Component, Input, OnInit } from "@angular/core";
import { LottieComponentComponent } from "../../components/lottie-component/lottie-component.component";
import ScrollReveal from "scrollreveal";

@Component({
  selector: "app-banner-typeb",
  templateUrl: "./banner-typeb.component.html",
  styleUrls: ["./banner-typeb.component.scss"],
})
export class BannerComponentTypeB implements OnInit {
  @Input() title: string = "";
  @Input() description: string = "";
  @Input() cta: string = "";
  @Input() event: string = "";
  @Input() img: string = "";
  @Input() url?: string = "";
  @Input() position?: string;
  @Input() positionContain?: boolean;
  @Input() className?: string[];
  @Input() variantClass?: string;
  @Input() shouldChangeTheDirectionOfTheAnimation?: boolean;
  @Input() src?: string;
  @Input() positionX: string = 'top';
  constructor() {}

  ngOnInit(): void {}
}
